window.PlummeI18n.register('en', {
  'adv.plan.viewForecast': 'View forecast',
  'adv.plan.forecastTitle': 'Cashflow with planned events',
  'adv.plan.forecastIntro': 'Compare the balance from posted figures with the balance after the events you entered.',
  'adv.plan.forecastWithoutEvents': 'Without planned events',
  'adv.plan.forecastWithEvents': 'With planned events',
  'adv.plan.forecastChange': 'Change at year end',
  'adv.plan.forecastScope': 'Planned events change the forecast only, not the books or budget. The curve stops at zero, so the year-end change can be smaller than the sum of the events.',
  'adv.plan.showVariance': 'Show variances',
  'adv.plan.hideVariance': 'Hide variances',
});
